import React, { useEffect, useState, useContext } from 'react'
import GeneralContext from '../../context/GeneralContext'
import styles from './DatosPersonales.module.css'

//Utiles
import * as Funciones from '../../utils/funciones'
import * as Constantes from '../../utils/constantes'
import Subtitle from '../Subtitle'
import CampoFecha from '../CampoFecha/CampoFecha'

const DatosPersonales = ({ contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [nacionalidades, setNacionalidades] = useState([])
    const [estados, setEstados] = useState([])
    const [vinculos, setVinculos] = useState([])
    let fechaPrueba = (contratante !== undefined && contratante !== null ? (contratante.fechaNacimiento) : null)

    const [inputDate, setInputDate] = useState(fechaPrueba)

    useEffect(() => {
        if (fechaPrueba !== '') {
            const fecha = new Date(contratante.fechaNacimiento)
            setInputDate({
                day: fecha.getDate(),
                month: fecha.getMonth(),
                year: fecha.getFullYear()
            })
        } else {
            setInputDate('')
        }

        setVinculos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 10))
        setEstados(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 14))
        setNacionalidades(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 40))
    }, [fechaPrueba])

    const onChangeInputDate = (valor) => {
        setInputDate(valor)
        handleChangeFecha(valor, 'fechaNacimiento')
    }

    const handleChangeTexto = (event, campo) => {
        let valor = event.target.value.replace(/\t/g, ' ').replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = Funciones.mostrarCamelCase(Funciones.limpiarTexto(valor))
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    [campo]: capital,
                    indicadorModificacionDatosPID: state.contratante.indicadorModificacionDatosPID === '1'
                        ? '2' : state.contratante.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeSexo = (event) => {
        const sexoVal = event.target.value
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    sexo: {
                        ...state.contratante.sexo,
                        codigo: parseInt(sexoVal)
                    },
                    indicadorModificacionDatosPID: state.contratante.indicadorModificacionDatosPID === '1'
                        ? '2' : state.contratante.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    sexo: true
                }
            }
        })
    }

    const handleChangeCombo = (event, campo) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    [campo]: {
                        codigo: parseInt(codigo),
                        descripcion: descripcion
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeFecha = (event, campo) => {
        let valor = event
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    [campo]: Funciones.transformarDatePickerToFecha(valor),
                    indicadorModificacionDatosPID: state.contratante.indicadorModificacionDatosPID === '1'
                        ? '2' : state.contratante.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    /*Obtener edad del contratante*/
    let nacimiento = state.contratante !== null ? inputDate : null
    let hoy = new Date()
    let edad = parseInt(hoy.getFullYear())
    let año = nacimiento !== null && nacimiento !== undefined ? nacimiento.year : null
    let edadActualApoderado = edad - año
    let mesesFechaActual = parseInt(hoy.getMonth())
    let mesesNacimiento = nacimiento !== null && nacimiento !== undefined ? nacimiento.month : null
    let diasActual = hoy.getDate()
    let obtenerFechaSeparadaPorDia = nacimiento !== null && nacimiento !== undefined ? nacimiento.day : null
    let cumpleaños = mesesNacimiento - 1 <= mesesFechaActual && diasActual >= obtenerFechaSeparadaPorDia ? 1 : 0
    let edadExacta = (edadActualApoderado - 1) + cumpleaños

    const handleOnKeyPress = (e) => {
        const dieresisRegex = /^[äëïöüÿÄËÏÖÜ]$/;

        if (dieresisRegex.test(e.key)) {
            e.preventDefault();
            return;
        }

        if (e.key && e.key.length === 1) {
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(e.key)) {
                e.preventDefault();
            }
        }
    };

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname='Datos Personales'
                smostrar='false'
            />
            <div>
                <div className={styles['contenedor2']}>
                    <div className={styles['caja-1']}>
                        <label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            className={!state.campoValidado.nombres ? styles['logerror'] : null}
                            value={contratante.nombres || ''}
                            onChange={(e) => handleChangeTexto(e, 'nombres')}
                            onKeyPress={handleOnKeyPress}
                            disabled={Deshabilitar() !== true ? false : true} 
                            maxLength={47}
                        />
                        {!state.campoValidado.nombres &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NOMBRES}</span>
                        }
                    </div>
                    <div className={styles['caja-2']}>
                        <label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            className={!state.campoValidado.apellidoPaterno ? styles['logerror'] : null}
                            value={contratante.apellidoPaterno || ''}
                            onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')}
                            onKeyPress={handleOnKeyPress}
                            disabled={Deshabilitar() !== true ? false : true} 
                            maxLength={40}
                        />
                        {!state.campoValidado.apellidoPaterno &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_PATERNO}</span>
                        }
                    </div>
                    <div className={styles['caja-3']}>
                        <label>Apellido Materno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            className={!state.campoValidado.apellidoMaterno ? styles['logerror'] : null}
                            value={contratante.apellidoMaterno || ''}
                            onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
                            onKeyPress={handleOnKeyPress}
                            disabled={Deshabilitar() !== true ? false : true}
                            maxLength={40}
                        />
                        {!state.campoValidado.apellidoMaterno &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_MATERNO}</span>
                        }
                    </div>
                    <div className={styles['caja-4']}>
                        <label>Sexo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <form>
                            <div className={styles["centered"]}>
                                <label className={styles['label-radio']}>
                                    <input type="radio"
                                        name="sexo"
                                        value={0}
                                        selected={contratante && contratante.sexo !== undefined && contratante.sexo.codigo === 0}
                                        checked={contratante && contratante.sexo !== undefined && contratante.sexo.codigo === 0}
                                        onChange={handleChangeSexo}
                                        disabled={Deshabilitar() !== true ? false : true} />
                                    <span className="span-radio-sexo">Femenino</span>
                                </label>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label className={styles['label-radio']}>
                                    <input type="radio"
                                        name="sexo"
                                        value={1}
                                        selected={contratante && contratante.sexo !== undefined && contratante.sexo.codigo === 1}
                                        checked={contratante && contratante.sexo !== undefined && contratante.sexo.codigo === 1}
                                        onChange={handleChangeSexo}
                                        disabled={Deshabilitar() !== true ? false : true} />
                                    <span className="span-radio-sexo">Masculino</span>
                                </label>
                            </div>
                            {!state.campoValidado.sexo &&
                                <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_SEXO}</span>
                            }
                        </form>
                    </div>
                </div>
                <div className={styles['contenedor2']}>
                    <div className={styles['caja-1']}>
                        <label>Nacionalidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <select
                            className={!state.campoValidado.nacionalidad ? styles['logerror'] : styles['tipoDoc']}
                            value={contratante.nacionalidad ? contratante.nacionalidad.codigo : ''}
                            onChange={(e) => handleChangeCombo(e, 'nacionalidad')}
                            disabled={Deshabilitar() !== true ? false : true}>
                            <option value={0}>Seleccione</option>
                            {nacionalidades && nacionalidades.length > 0 && nacionalidades.map(nacionalidad => (
                                <option key={nacionalidad.id} value={nacionalidad.id}>
                                    {nacionalidad.valor}
                                </option>
                            ))}
                        </select>
                        {!state.campoValidado.nacionalidad &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NACIONALIDAD}</span>
                        }
                    </div>
                    {/*Se utiliza el componente CampoFecha */}
                    <div className={!state.campoValidado.fechaNacimiento ? styles['caja-2p'] : edadExacta < 18 ? styles['caja-2p']
                        : styles['caja-2']}>
                        <CampoFecha
                            name={'Fecha Nacimiento'}
                            esObligatorio={true}
                            valor={contratante && contratante.fechaNacimiento && contratante.fechaNacimiento !== '1901-01-01' ?
                                Funciones.transformarFechaToDatePicker(contratante.fechaNacimiento)
                                : ''}
                            disabled={Deshabilitar() !== true ? false : true}
                            onChange={(valor) => onChangeInputDate(valor)}
                            validacion={state.campoValidado.fechaNacimiento}
                            mensaje={Constantes.MENSAJE_VALIDACION_FEC_NACIMIENTO}
                            edad={edadExacta}
                        />
                    </div>
                    <div className={styles['caja-3']}>
                        <label>Estado Civil&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <select
                            className={!state.campoValidado.estadoCivil ? `${styles['logerror']} ${styles['estadoCivil']}` : styles['estadoCivil']}
                            value={contratante.estadoCivil ? contratante.estadoCivil.codigo : ''}
                            onChange={(e) => handleChangeCombo(e, 'estadoCivil')}
                            disabled={Deshabilitar() !== true ? false : true}>
                            <option value={0}>Seleccione</option>
                            {estados && estados.length > 0 && estados.map(estado => (
                                <option key={estado.id} value={estado.id}>
                                    {estado.valor}
                                </option>
                            ))}
                        </select>
                        {!state.campoValidado.estadoCivil &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EST_CIVIL}</span>
                        }
                    </div>
                    <div className={styles['caja-4']}>
                        <label>Vinculo con el asegurado&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <select
                            className={!state.campoValidado.vinculo ? `${styles['logerror']} ${styles['vinculo']}` : styles['vinculo']}
                            value={contratante.vinculo ? contratante.vinculo.codigo : ''}
                            onChange={(e) => handleChangeCombo(e, 'vinculo')}
                            disabled={Deshabilitar() !== true ? false : true}>
                            <option value={0}>Seleccione</option>
                            {vinculos && vinculos.length > 0 && vinculos.map(vinculo => (
                                <option key={vinculo.id} value={vinculo.id}>
                                    {vinculo.valor}
                                </option>
                            ))}
                        </select>
                        {!state.campoValidado.vinculo &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_VINCULO}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DatosPersonales